/* eslint-disable no-console */
import axios from "axios";
import { BaseApi } from "./base-api";
import { AppConfig } from "../config/app-config";
import { getToken } from "../auth-helper";

const resourceKey = "connections";

export const ConnectionsApi = {
  list: () => BaseApi.list(resourceKey),
  retrieve: (pk: number) => BaseApi.retrieve(resourceKey, pk),
  create: (params: any) => BaseApi.create(resourceKey, params),
  update: (pk: number, params: any) => BaseApi.update(resourceKey, pk, params),
  destroy: (pk: number) => BaseApi.destroy(resourceKey, pk),
  checkConnection: (
    host: string,
    port: string,
    username: string,
    password: string,
    path: string
  ) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/connections/check_connection/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.post(
      url,
      {
        host,
        username,
        password,
        port,
        path,
      },
      {
        headers: {
          Authorization: `JWT ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  glob: (
    host: string,
    username: string,
    password: string,
    port: string,
    path: string,
    recursive: boolean
  ) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/connections/glob/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.post(
      url,
      {
        host,
        username,
        password,
        port,
        path,
        recursive,
      },
      {
        headers: {
          Authorization: `JWT ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
